// src/store/modules/portfolio/actions.js

import { get, post } from '@/services/api';
export default {
  async createAndAddPortfolio({ commit }, payload) {
    try {
      const res = await post('portfolio/create-and-add-portfolio', {
        portfolioName: payload.portfolioName,
        portfolioStart: payload.portfolioStart,
        isActive: payload.isActive,
        tradeIdList: payload.tradeIdList,
        portfolioType: payload.portfolioType
      });
      return res.data;
    } catch (err) {
      console.error('createAndAddPortfolio failed', err);
      throw err;
    }
  },
  async createAndAddPastPortfolio({ commit }, payload) {
    try {
      const res = await post('portfolio/create-and-add-past-portfolio', {
        portfolioName: payload.portfolioName,
        portfolioStart: payload.portfolioStart,
        portfolioEnd: payload.portfolioEnd,
        isActive: payload.isActive,
        portfolioType: payload.portfolioType,
        tradeIdList: payload.tradeIdList,
      });
      return res.data;
    } catch (err) {
      console.error('createAndAddPortfolio failed', err);
      throw err;
    }
  },
  async markPortfolioClosed({ commit }, payload) {
    console.log('payload.Portfolio ID:', payload.portfolioId)
    console.log('payload.Portfolio End Date:', payload.portfolioEndDate)
    try {
      const res = await post('portfolio/mark-portfolio-closed', {
        portfolioId: payload.portfolioId,
        portfolioEndDate: payload.portfolioEndDate,
      });
      return res.data;
    } catch (err) {
      console.error('markPortfolioClosed failed', err);
      throw err;
    }
  },
  async getPortfolioInfoList(context, { fromDate, toDate, offset, count, portfolioType }) {
    try {
      const response = await get(
        `/portfolio/get-portfolio-info-list?offset=${offset}&count=${count}&fromDate=${fromDate}&toDate=${toDate}&portfolioType=${portfolioType}`
      );
      return response.data;
    } catch (err) {
      console.error('getPortfolioInfoList failed', err);
      throw err;
    }
  },
  async getPortfolioTrade(context, portfolioPayload = {}) {
    // Extract the ID whether it's nested or passed directly as the object
    const portfolioId = portfolioPayload.portfolioId || portfolioPayload;
    
    console.log('📦 getPortfolioTrade in action', portfolioId);
    
    try {
      // URLSearchParams cleanly handles query strings without messy ternary operators
      const params = new URLSearchParams();
      if (portfolioId && typeof portfolioId === 'string') {
        params.append('portfolioId', portfolioId);
      }
      
      const queryString = params.toString() ? `?${params.toString()}` : '';
      const response = await get(`/portfolio/get-portfolio-trade${queryString}`);
      
      return response.data;
    } catch (err) {
      console.error('getPortfolioTrade failed', err);
      throw err;
    }
  },
  async getLastPortfolioTrade(context) {
    console.log('📦 getLastPortfolioTrade in action');
    try {
      const url = `/portfolio/get-portfolio-trade`;
      const response = await get(url);
      return response.data;
    } catch (err) {
      console.error('getLastPortfolioTrade failed', err);
      throw err;
    }
  },
  
  async getMfMasterList(context, { schemeName } = {}) {
    console.log('📦 getMfMasterList in action');
    console.log('servicenaem' + schemeName)
    try {
      const url = `/mfportfolio/get-mf-p-master-list?schemeName=${schemeName}`;
      const response = await get(url);
      return response.data;
    } catch (err) {
      console.error('getLastPortfolioTrade failed', err);
      throw err;
    }
  },
  async getMfPortfolio(context) {
    console.log('📦 getMfPortfolio in action');
    try {
      const url = `/mfportfolio/get-mf-portfolio-info-list`;
      const response = await get(url);
      return response.data;
    } catch (err) {
      console.error('getLastPortfolioTrade failed', err);
      throw err;
    }
  },
  
  async addMfToPortfolio({ commit }, payload) {
  // Option A: Expandable object in devtools (recommended)
  console.log('📦 addMfToPortfolio payload:', payload);

  // Option B: Full formatted JSON string
  // console.log('📦 addMfToPortfolio payload:', JSON.stringify(payload, null, 2));

  try {
    const res = await post('mfportfolio/add-mf-to-portfolio', {
      isin: payload.isin,
      schemeCode: payload.schemeCode,
      bucketType: payload.bucketType,
      quantity: payload.quantity,
      userMfAccountId: payload.userMfAccountId,
      transactionDate: payload.transactionDate
    });
    return res.data;
  } catch (err) {
    console.error('addMfToPortfolio failed', err);
    throw err;
  }
},

   async removeMfFromPortfolio({ commit }, payload) {
    console.log('📦 removeMfFromPortfolio in action');
    try {
      const res = await post('mfportfolio/remove-mf-from-portfolio', {
        isin: payload.isin
      });
      return res.data;
    } catch (err) {
      console.error('removeMfFromPortfolio failed', err);
      throw err;
    }
  },

  async redeuceMfFromPortfolio({ commit }, payload) {
    console.log('📦 redeuceMfFromPortfolio in action');
    try {
      const res = await post('mfportfolio/reduce-mf-from-portfolio', {
        isin: payload.isin,
        quantity: payload.quantity,
      });
      return res.data;
    } catch (err) {
      console.error('redeuceMfFromPortfolio failed', err);
      throw err;
    }
  },
  async getMyMfAccountDataList(context) {
    console.log('📦 getMyMfAccountDataList in action');
    try {
      const url = `/mfportfolio/get-my-mf-account-data-list`;
      const response = await get(url);
      return response.data;
    } catch (err) {
      console.error('getMyMfAccountDataList failed', err);
      throw err;
    }
  },
  async updateUserMfAccountName({ commit }, payload) {
    console.log('📦 updateUserMfAccountName in action');
    try {
      const res = await post('mfportfolio/update-user-mf-account-name', {
        isin: payload.isin,
        accountName: payload.accountName,
      });
      return res.data;
    } catch (err) {
      console.error('updateUserMfAccountName failed', err);
      throw err;
    }
  },
 async getMfPortfolioValue(context) {
    console.log('📦 getMfPortfolioValue in action');
    try {
      const url = `/mfportfolio/get-mf-portfolio-value`;
      const response = await get(url);
      return response.data;
    } catch (err) {
      console.error('getMfPortfolioValue failed', err);
      throw err;
    }
  },
  async getMfPortfolioValueHisory(context) {
    console.log('📦 getMfPortfolioValueHisory in action');
    try {
                    
      const url = `/mfportfolio/get-mf-portfolio-value-hisory`;
      const response = await get(url);
      return response.data;
    } catch (err) {
      console.error('getMfPortfolioValueHisory failed', err);
      throw err;
    }
  },
  async refreshMaster () {   
    console.log('📦 refresh master in action');
    try {
      const response = await post(`/mfportfolio/refresh-master`);
      console.log(`📦 refresh master API response:`, response.data);
      
    } catch (error) {
      console.error('❌ refresh master API error:', error);
      throw error;
    }
  },
  async updateFundBucket({ commit }, payload) {
    console.log('📦 updateFundBucket in action');
    try {
      const res = await post('mfportfolio/update-fund-bucket', {
        schemeCode: payload.schemeCode,
        bucketType: payload.bucket,
      });
      return res.data;
    } catch (err) {
      console.error('updateFundBucket failed', err);
      throw err;
    }
  },
};
